import { useContext } from 'react';
import { createRegisteredContext } from 'react-singleton-context';
var ModulesContext = createRegisteredContext('ModulesContext', {});
export var useModulesContext = function useModulesContext() {
  var ctx = useContext(ModulesContext);
  if (!ctx) throw new Error('"ModulesContext.Provider" is missing');
  return ctx;
};
export default ModulesContext;